export const escapeQueryForRelevanceScoring = (query: string) => {
  const specialCharacters = ["+", "-", "*", '"', ">", "<", "~", "(", ")", "@", "&", "|"];
  let escapedQuery = query.trim();

  specialCharacters.forEach((char) => {
    const regex = new RegExp(`\\${char}`, "g");
    escapedQuery = escapedQuery
      // normalize the dash inputs sp they are all captured by our blacklist
      .replace(/[\u2013\u2014\u2015]/g, "-")
      .replace(regex, "");
  });

  // Add wildcard at the end of each word
  // NOTE prisma mysql full text search cannot perform partial matches after the beginning of a word,
  // so we can't simply wildcard before the word :(
  escapedQuery = escapedQuery
    .split(/\s+/) // Split by whitespace
    .map((word) => (word ? `${word}*` : "")) // Add wildcard to end of each word
    .join(" "); // Join words back into a string

  return escapedQuery;
};

export const escapeQueryForSearching = (query: string) => {
  return query.trim();
};
